var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2953 29.9895H38.5525C36.8482 29.9895 35.2137 29.3125 34.0085 28.1074C32.8034 26.9023 32.1264 25.2678 32.1264 23.5634V4.82066C32.1264 4.67864 32.07 4.54243 31.9695 4.442C31.8691 4.34158 31.7329 4.28516 31.5909 4.28516H19.2742C17.0018 4.28516 14.8224 5.18787 13.2156 6.7947C11.6088 8.40154 10.7061 10.5809 10.7061 12.8533V55.6939C10.7061 57.9664 11.6088 60.1457 13.2156 61.7525C14.8224 63.3594 17.0018 64.2621 19.2742 64.2621H49.2626C51.5351 64.2621 53.7144 63.3594 55.3212 61.7525C56.9281 60.1457 57.8308 57.9664 57.8308 55.6939V30.5251C57.8308 30.383 57.7744 30.2468 57.6739 30.1464C57.5735 30.046 57.4373 29.9895 57.2953 29.9895Z",
    fill: "#321E5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1234 25.2487L36.8706 5.99583C36.8331 5.95861 36.7855 5.93329 36.7337 5.92305C36.682 5.91281 36.6283 5.91811 36.5795 5.93829C36.5307 5.95846 36.489 5.99261 36.4595 6.03643C36.4301 6.08026 36.4143 6.13181 36.4141 6.1846V23.5632C36.4141 24.1313 36.6397 24.6761 37.0414 25.0778C37.4432 25.4795 37.988 25.7052 38.5561 25.7052H55.9347C55.9875 25.705 56.039 25.6892 56.0828 25.6597C56.1267 25.6303 56.1608 25.5886 56.181 25.5398C56.2012 25.491 56.2065 25.4373 56.1962 25.3855C56.186 25.3337 56.1607 25.2861 56.1234 25.2487Z",
    fill: "#321E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonDocument);
export default __webpack_public_path__ + "static/media/ion_document.335a2803a6d14b5d1e065c9a6a4e86c2.svg";
export { ForwardRef as ReactComponent };